import React from 'react';
import { Select } from 'antd';
import type { BaseOptionType, DefaultOptionType } from 'antd/es/select';
import * as S from './styles';

type SelectOptionsProps = React.ComponentProps<typeof Select> & {
	showSearch?: boolean;
};

export function SelectOptions({ showSearch = true, allowClear = true, ...props }: Readonly<SelectOptionsProps>) {
	function handleShowSearch(input: string, option?: BaseOptionType | DefaultOptionType): boolean {
		const label = typeof option?.label === 'string' ? option.label : '';
		return label.toLowerCase().includes(input.toLowerCase());
	}

	return (
		<S.SelectWrapper
			{...props}
			showSearch={showSearch}
			allowClear={allowClear}
			filterOption={showSearch ? handleShowSearch : false}
		/>
	);
}
